import firebase from 'firebase/compat/app';
import Timestamp = firebase.firestore.Timestamp;
import GeoPoint = firebase.firestore.GeoPoint;

export interface CurrentUser {
  id: string,
  createdAt: Timestamp,
  email: string,
  name: string,
  admin: boolean,
  userType: string,
  hasSetPassword: boolean | undefined,
  business: string | undefined,
}

export interface UserCard {
  id: string,
  cardNumber: string,
  createdAt: Timestamp,
  status: string,
  points: number,
  expiresAt: Timestamp,
  business: string,
  user: string,
  userName: String,
}

export interface BusinessConfiguration {
  pointsPerEuro: number,
  eventsEnabled: boolean,
  card: CardConfiguration,
}

export interface LocationConfiguration {
  locationImageUrl: string,
}

export interface CardConfiguration {
  bgColour: string,
  fgColour: string,
  font: string,
  fontWeight: number,
  toUpperCase: boolean,
}

export interface LocationTypeTags {
  sellsAlcohol: boolean,
  sellsFood: boolean,
}

export interface Business {
  id: string,
  createdAt: Timestamp,
  active: boolean,
  name: string,
  locations: Array<string>,
  configuration: BusinessConfiguration,
  businessNumber: number,
  cardSequence: number,
  status: string,
}

export interface LocationOffer {
  id: string,
  business: string,
  location: string,
  description: string,
  pointsCost: number,
  limitPerCard: number,
  cardClaimCounts: Map<string, number>,
  expiresAt: Timestamp | undefined,
  createdAt: Timestamp,
}

export interface OfferClaim {
  id: string,
  offer: string,
  claimNumber: number,
  user: string,
  userName: string,
  card: string,
  createdAt: Timestamp,
}

export interface LocationEvent {
  id: string,
  createdAt: Timestamp,
  active: boolean,
  description: string,
  business: string,
}

export interface BusinessLocation {
  id: string,
  createdAt: Timestamp,
  active: boolean,
  address: string,
  city: string,
  country: string,
  postCode: string,
  location: GeoPoint,
  business: string,
  status: string,
  typeTags: LocationTypeTags,
  configuration: LocationConfiguration,
}

export interface CardTransaction {
  id: string,
  card: string,
  points: number,
  type: string,
  linkedOffer: string | undefined,
  business: string,
  createdAt: Timestamp,
}

export interface MenuSection {
  id: string,
  description: string,
  order: number,
}

export interface MenuItem {
  id: string,
  description: string,
  subDescription: string,
  order: number,
  price: number,
  createdAt: Timestamp,
}

export enum UserType {
  CUSTOMER = "CUSTOMER",
  LOCATION_MANAGER = "LOCATION_MANAGER",
}

// Function Types
export interface CreateCardRequest {
  business: string,
}